import PropTypes from 'prop-types';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
import useLocales, { getLanguage } from '~/hooks/use_locales';
import useMst from '~/hooks/use_mst';
import { ReactNode } from 'react';

const ThemeLocalizationProps = {
  children: PropTypes.node.isRequired
};

type ThemeLocalizationPropsType = {
  children: ReactNode;
};

export default function ThemeLocalization({ children }: ThemeLocalizationPropsType) {
  const defaultTheme = useTheme();
  const { i18n } = useLocales();
  const { auth } = useMst();

  // Use auth.user.locale if available, otherwise fall back to i18n.language
  const locale = auth.user?.locale || i18n.language;

  // Get the localization object for the locale
  const localization = getLanguage(locale).systemValue;

  const theme = createTheme(defaultTheme, localization);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

ThemeLocalization.propTypes = ThemeLocalizationProps;
